import { apiRequest } from '@/utils/api-request';

export interface CatalogItem {
  node_id: string;
  display_name: string;
  description: string;
  node_type: string;
  category: string;
  icon: string;
}

export interface AdminCatalogResponse {
  success: boolean;
  total_nodes: number;
  catalog: CatalogItem[];
}

export const getAdminCatalog = async (): Promise<CatalogItem[]> => {
  const response = await apiRequest<AdminCatalogResponse>({
    url: '/nodes/admin/catalog',
    method: 'GET',
    target: 'workflow',
  });

  if (response?.detail) {
    throw new Error(response.detail);
  }

  return response?.data?.catalog || [];
};
